import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
// Create an object by filtering all undefined props from the object supplied as a param

export default function filterObject(obj) {
  var filteredValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [undefined];
  var mutableObj = obj;
  Object.keys(mutableObj).forEach(function (key) {
    if (filteredValues.includes(mutableObj[key])) {
      delete mutableObj[key];
    }
  });
  return obj;
}